import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { Flex } from 'ui';
import { injectIntl } from 'react-intl';
import errorImage from '../../../assets/images/error_image.png';

const Title = styled.div`
  text-align: center;
  margin-top: 50px;
  font-size: 48px;
  color: ${p => p.theme.colors.theme};
  font-weight: 400;
`;

const Container = styled.div`
  width: 36%;
`;

const Text = styled.div`
  font-size: 16px;
  white-space: pre-wrap;
`;

const SubText = styled.div`
  margin: 30px 0;
  font-size: 12px;
`;

const Image = styled.div`
  text-align: center;
  margin: 50px 0;
`;

const NotFoundErrorPage = ({ type, value, referenceId = '', intl }) =>
  <Flex aic jcc ffcn>
    <Container>
      <Title>{intl.formatMessage({ id: 'direct.NOT_FOUND_TITLE' })}</Title>
      <Image><img src={errorImage} /></Image>
      <Text>
        {/* This is legacy in react-intl 4,
              we'll need to adjust this in next dependency bump */}
        {intl.formatMessage(
          { id: 'direct.NOT_FOUND_DESCRIPTION' },
          {
            searchedKeyAndValue: value,
            object: type,
            b: msg => <b>{msg}</b>,
          },
        )}
      </Text>
      <SubText>{intl.formatMessage({ id: 'direct.NOT_FOUND_ID_ERROR' }, { referenceId })}</SubText>
    </Container>
  </Flex >;
NotFoundErrorPage.propTypes = {
  type: PropTypes.string,
  value: PropTypes.string,
  referenceId: PropTypes.string,
  intl: PropTypes.object,
};

export default injectIntl(NotFoundErrorPage);
